/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `PARKING` - Parking
 * * `DEFAULT` - Default
 */
export type GigAttachmentTypeEnum = typeof GigAttachmentTypeEnum[keyof typeof GigAttachmentTypeEnum];


export const GigAttachmentTypeEnum = {
  PARKING: 'PARKING',
  DEFAULT: 'DEFAULT',
} as const;
